import { isNil } from 'ramda'
import { get } from '@/api/exam/room'
import { notify } from '@/utils/notification'
import { ExamRoom } from '@/models/exam/room'

export const sort = (a: ExamRoom, b: ExamRoom) =>
  Number.parseInt(a.roomId) - Number.parseInt(b.roomId)

export const fetchExamRoomList = async (id: string) => {
  if (isNil(id)) return []

  try {
    const data = await get(id, { current: 1, pageSize: 99999 })
    const rows = (data && data.rows) || []
    return rows.sort(sort)
  } catch (e) {
    notify(`获取考场列表失败`, e)
    return []
  }
}

export const getRoomName = (room: ExamRoom) => {
  return room.university + room.building + room.room
}

export const completion = (room: ExamRoom) => {
  return { ...room, name: getRoomName(room) }
}
